import clsx from "clsx";
import {
  StyledFormLabel,
  StyledFormLabelWithIcon,
  StyledProgessLabel,
  StyledStepDescriptionLabel,
  StyledStepNameLabel,
} from "./label.styles";
import { CustomTooltip } from "../../organisms/Tooltip";
import { Info } from "../../../assets/icons";

export const StepNameLabel = ({ children, ...props }) => {
  return <StyledStepNameLabel {...props}>{children}</StyledStepNameLabel>;
};

export const StepDescriptionLabel = ({ children, ...props }) => {
  return <StyledStepDescriptionLabel {...props}>{children}</StyledStepDescriptionLabel>;
};

export const FormLabel = ({ children, ...props }) => {
  return <StyledFormLabel {...props}>{children}</StyledFormLabel>;
};

export const FormLabelWithIcon = ({ label, hoverText, required, name, className = "" }) => {
  return (
    <>
      {!hoverText && (
        <FormLabel className={clsx({ req: required })} htmlFor={name}>
          {label}
        </FormLabel>
      )}
      {hoverText && (
        <StyledFormLabelWithIcon className={className} htmlFor={name}>
          <span className={clsx({ req: required })}>{label}</span>

          <CustomTooltip text={hoverText}>
            <Info />
          </CustomTooltip>
        </StyledFormLabelWithIcon>
      )}
    </>
  );
};

export const ProgressLabel = ({ children, ...props }) => {
  return <StyledProgessLabel {...props}>{children}</StyledProgessLabel>;
};
